import { FC } from 'react';

/* eslint-disable import/no-duplicates */
import { format, isAfter, isBefore } from 'date-fns';
import el from 'date-fns/locale/el';
/* eslint-enable import/no-duplicates */

const START_DATE = new Date('2024-02-09T00:00:00.000+02:00');
const END_DATE = new Date('2024-03-25T23:59:00.000+02:00');

interface Props {
  projectName: string;
  startDate?: Date;
  endDate?: Date;
}

export const UnavailableModalContent: FC<Props> & { isUnavailable: (startDate?: Date, endDate?: Date) => boolean } & {
  isAfterUnavailable: (endDate?: Date) => boolean;
} & { isBeforeUnavailable: (startDate?: Date) => boolean } = ({
  projectName,
  startDate = START_DATE,
  endDate = END_DATE,
}) => {
  const today = new Date();

  if (isAfter(startDate, today)) {
    return (
      <div>
        Οι αιτήσεις για τη δράση <strong>{projectName}</strong> του προγράμματος EQUALL ξεκινούν στις{' '}
        {format(startDate, 'dd MMMM yyyy', {
          locale: el,
        })}
        .
        <br /> <br /> Stay tuned!
      </div>
    );
  }

  if (isBefore(endDate, today)) {
    return (
      <div>
        Οι δηλώσεις συμμετοχής για τη δράση <strong>{projectName}</strong> του προγράμματος EQUALL ολοκληρώθηκαν στις{' '}
        {format(endDate, 'dd MMMM yyyy', {
          locale: el,
        })}
        .
        <br /> <br /> Stay tuned για τον επόμενο κύκλο!
      </div>
    );
  }

  return null;
};

UnavailableModalContent.isAfterUnavailable = (endDate = END_DATE) => {
  const today = new Date();
  return isAfter(today, endDate);
};

UnavailableModalContent.isBeforeUnavailable = (startDate = START_DATE) => {
  const today = new Date();
  return isBefore(today, startDate);
};

UnavailableModalContent.isUnavailable = (startDate = START_DATE, endDate = END_DATE) => {
  const today = new Date();
  return isAfter(startDate, today) || isBefore(endDate, today);
};
